module.exports = __webpack_public_path__ + "img/jeroen.2f113b64.png";